import {CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {RouterModule, Routes} from '@angular/router';

import {IonicModule} from '@ionic/angular';

import {TranslateModule} from '@ngx-translate/core';
import {EffectsModule} from '@ngrx/effects';
import {SopiScrollModule} from '../../../../sopi/components/sopi-scroll/sopi-scroll.module';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {ChecklistenAufgabenPage} from './checklisten-aufgaben.page';
import {FunktionsbereicheChecklistenPageModule} from '../funktionsbereiche-checklisten/funktionsbereiche-checklisten.module';
import {FunktionsbereichChecklistenAufgabenPageModule} from '../funktionsbereich-checklisten-aufgaben/funktionsbereich-checklisten-aufgaben.module';
import {AufgabePageModule} from '../aufgabe/aufgabe.module';
import {SopiComponentsModule} from '../../../shared/sopi-components/sopi-components.module';

const routes: Routes = [
    {
        path: '',
        component: ChecklistenAufgabenPage,
        data: {title: 'Checklisten und Aufgaben'}
    }

];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        TranslateModule,
        EffectsModule.forFeature([]),
        SopiScrollModule,
        DragDropModule,
        FunktionsbereicheChecklistenPageModule,
        FunktionsbereichChecklistenAufgabenPageModule,
        AufgabePageModule,
        SopiComponentsModule.forRoot(),
    ],
    declarations: [ChecklistenAufgabenPage],
    entryComponents: [ChecklistenAufgabenPage],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ChecklistenAufgabenPageModule {
    public static forRoot(): ModuleWithProviders {
        return {
            ngModule: ChecklistenAufgabenPageModule,
        };
    }
}
